import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-12 mb-3" }
const _hoisted_15 = { class: "form-group password-field" }
const _hoisted_16 = { class: "password-input-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "form-text text-muted"
}
const _hoisted_18 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-lg",
    title: _ctx.isCreateMode ? 'Создание пользователя' : _ctx.$t('users.editUser')
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.entrance.fields.lastName.label')), 1),
              _createVNode(_component_input_ui, {
                modelValue: _ctx.state.lastName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.lastName) = $event)),
                placeholder: _ctx.$t('modals.entrance.fields.lastName.placeholder')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.entrance.fields.firstName.label')), 1),
              _createVNode(_component_input_ui, {
                modelValue: _ctx.state.firstName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.firstName) = $event)),
                placeholder: _ctx.$t('modals.entrance.fields.firstName.placeholder')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.entrance.fields.middleName.label')), 1),
              _createVNode(_component_input_ui, {
                modelValue: _ctx.state.middleName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.middleName) = $event)),
                placeholder: _ctx.$t('modals.entrance.fields.middleName.placeholder')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.entrance.fields.iin.label')), 1),
              _createVNode(_component_input_ui, {
                modelValue: _ctx.state.iin,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.iin) = $event)),
                placeholder: _ctx.$t('modals.entrance.fields.iin.placeholder')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.entrance.fields.phone.label')), 1),
              _createVNode(_component_input_ui, {
                modelValue: _ctx.state.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.phone) = $event)),
                mask: '+7 (###) ### ## ##',
                placeholder: "+7 (000) 000 00 00"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('users.login')), 1),
              _createVNode(_component_input_ui, {
                modelValue: _ctx.state.login,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.login) = $event)),
                placeholder: _ctx.$t('users.login')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('users.password')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.password,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.password) = $event)),
                  type: _ctx.state.showPassword ? 'text' : 'password',
                  placeholder: _ctx.$t('users.password')
                }, null, 8, ["modelValue", "type", "placeholder"]),
                _createElementVNode("button", {
                  class: "btn btn-link btn-sm password-toggle",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.showPassword = !_ctx.state.showPassword))
                }, [
                  _createVNode(_component_vue_feather, {
                    size: "16",
                    type: _ctx.state.showPassword ? 'eye-off' : 'eye'
                  }, null, 8, ["type"])
                ])
              ]),
              (!_ctx.isCreateMode)
                ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.$t('users.passwordMinLength')) + " (оставьте пустым, если не хотите менять пароль) ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.user.isSuperAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", null, "Роль", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.roleAlias) = $event)),
                    class: "form-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRoles, (role) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: role.alias,
                        value: role.alias
                      }, _toDisplayString(role.label), 9, _hoisted_20))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.state.roleAlias]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_button_ui, {
              "button-class": "btn-secondary me-2",
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ui.cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_button_ui, {
              "button-class": "btn-primary",
              type: "submit",
              disabled: _ctx.state.loader
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ui.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}